<script>
import { Bar, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import stacked100 from 'chartjs-plugin-stacked100'

export default {
  extends: Bar,
  name: 'chart-bar',
  mixins: [Bar, mixins.reactiveProp],
  plugins: [ChartDataLabels, stacked100],
  props: ['chartData', 'options'],
  data () {
    return {
    }
  },
  watch: {
    options () {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
